TPS.AVVehicleList = {
    isInitialized: false,
    placeholderSel: '#vehicle-list-placeholder',

    init: function () {
        var _self = TPS.AVVehicleList;
        if (_self.isInitialized) return;

        var $placeholder = jQuery(_self.placeholderSel);
        if ($placeholder.length === 0) return;

        var culture = document.getElementById('lng').value;

        $placeholder.html('<div class="vehicle-list-loading text-center">' + TPS.Util.submitSpinner + '</div>');

        TPS.Util.loadWebserviceJS('CMSApp.AV.API.Vehicle');

        CMSApp.AV.API.Vehicle.GetAPlanVehicles(
            culture,
            function (categories) { _self.render($placeholder, categories); },
            function (err) {
                console.error('TPS.AVVehicleList: GetAPlanVehicles failed', err);
                $placeholder.empty();
            }
        );

        _self.isInitialized = true;
    },

    render: function ($placeholder, categories) {
        var _self = TPS.AVVehicleList;
        if (!categories || categories.length === 0) {
            $placeholder.empty();
            return;
        }

        var html = categories.map(function (cat) {
            if (!cat.Vehicles || cat.Vehicles.length === 0) return '';
            var items = cat.Vehicles.map(_self.renderItem).join('');
            return '' +
                '<div class="vehicle-list-wrapper">' +
                    '<h2 class="vehicle-list-category">' + _self.escapeHtml(cat.Name) + '</h2>' +
                    '<div class="vehicle-list row medium-up-1 medium-up-2 large-up-3 xlarge-up-4">' +
                        items +
                    '</div>' +
                '</div>';
        }).join('');

        $placeholder.html(html);
    },

    renderItem: function (v) {
        var _self = TPS.AVVehicleList;
        var displayName = [v.PreName, v.Name, v.PostName].filter(Boolean).join(' ').trim();
        var imageSrc = (v.Images && v.Images.length > 0) ? v.Images[0] : '';
        var bonus = _self.formatCurrency(v.MaxSaving);
        var href = v.URL || '';

        var tagOpen = href
            ? '<a href="' + _self.escapeAttr(href) + '" class="vehicle-list-item column column-block" data-cat="">'
            : '<div class="vehicle-list-item column column-block" data-cat="">';
        var tagClose = href ? '</a>' : '</div>';

        return '' +
            tagOpen +
                '<div class="vehicle-list-item-inner">' +
                    '<div class="vehicle-list-item-top">' +
                        '<div class="vehicle-name">' + _self.escapeHtml(displayName) + '</div>' +
                        '<div class="vehicle-price-wrapper">' +
                            `${window.Labels.ProgramBonus}<span class="vehicle-price-value">` + bonus + '</span>' +
                        '</div>' +
                    '</div>' +
                    '<div class="vehicle-list-item-bottom">' +
                        (imageSrc ? '<img src="' + _self.escapeAttr(imageSrc) + '" alt="" aria-hidden="true" />' : '') +
                    '</div>' +
                '</div>' +
            tagClose;
    },

    formatCurrency: function (_amt) {

        var lang = document.getElementById('lng').value;

        if (typeof _amt !== 'number') {
            return _amt;
        }

        if (lang === 'fr-CA') {
            return `${Math.round(_amt)} $`;
        }
        else {
            return `$${Math.round(_amt)}`
        }
    },

    escapeHtml: function (s) {
        if (s == null) return '';
        return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    },

    escapeAttr: function (s) {
        if (s == null) return '';
        return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;');
    }
};

jQuery(document).ready(function () {
    if (document.body && document.body.dataset && document.body.dataset.tpsTemplate === 'APlanVehicleList') {
        TPS.AVVehicleList.init();
    }
});


TPS.AVVehicleDetail = {
    isInitialized: false,
    savingsAmountSel: '.savings-amount',

    init: function () {
        var _self = TPS.AVVehicleDetail;
        if (_self.isInitialized) return;

        var $amount = jQuery(_self.savingsAmountSel).first();
        if ($amount.length === 0) return;

        var vehicleID = parseInt($amount.data('vehicle-id'), 10);
        if (!vehicleID) {
            vehicleID = parseInt(jQuery('#vehicleID').val(), 10);
        }
        if (!vehicleID) {
            console.error('TPS.AVVehicleDetail: missing vehicle ID (expected data-vehicle-id on .savings-amount or #vehicleID hidden input)');
            return;
        }

        var culture = document.getElementById('lng').value;
        var originalValue = $amount.html();
        $amount.html(TPS.Util.submitSpinner);

        TPS.Util.loadWebserviceJS('CMSApp.AV.API.Vehicle');

        CMSApp.AV.API.Vehicle.GetAPlanVehicle(
            vehicleID,
            culture,
            function (vehicle) {
                if (vehicle && typeof vehicle.MaxSaving === 'number') {
                    $amount.text(TPS.AVVehicleList.formatCurrency(vehicle.MaxSaving));
                } else {
                    $amount.html(originalValue);
                }

                if (vehicle) {
                    _self.updatePrevNext(vehicle.PreviousVehicleURL, vehicle.NextVehicleURL);
                }
            },
            function (err) {
                console.error('TPS.AVVehicleDetail: GetAPlanVehicle failed', err);
                $amount.html(originalValue);
            }
        );

        _self.isInitialized = true;
    },

    updatePrevNext: function (prevUrl, nextUrl) {
        var $nav = jQuery('[data-billboard-vehicle-prev-next]');
        if ($nav.length === 0) return;

        if (prevUrl) {
            $nav.find('.prev').attr('href', prevUrl).removeClass('hidden');
        }
        if (nextUrl) {
            $nav.find('.next').attr('href', nextUrl).removeClass('hidden');
        }
    }
};

jQuery(document).ready(function () {
    if (document.body && document.body.dataset && document.body.dataset.tpsTemplate === 'APlanVehicleDetail') {
        TPS.AVVehicleDetail.init();
    }
});
